//Archivo dedicado al menu de todos los imports de EQUITAS

//Imports relacionados de FORSETI
//-----------Principal-----------
import Plantilla from '@/components/EQUITAS/Comun/Plantilla.vue';

//-----------Notificaciones-----------
import NotificacionElectronicaAntiguo from '@/components/EQUITAS/Notificaciones/NotificacionElectronicaAntiguo/Index.vue';

const EQUITAS = [
    {
      name: 'EQUITAS', path: '/EQUITAS/', component: Plantilla, meta: { tituloDeLaPagina: "EQUITAS (Sistema especializado en la materia mercantil, civil y familiar)", RequiereAutenticacion: true, ValidaSesion: true, ObtenDatos: true, ObtenPermisosDelSistema: true, SistemaQueSeIngreso: 25 }, children: [
        { name: 'NotificacionElectronicaAntiguo', path: 'NotificacionElectronicaAntiguo', component: NotificacionElectronicaAntiguo, meta: { tituloDeLaPagina: "Notificación Electrónica Antiguo", RequiereAutenticacion: true, ValidaSesion: true, ObtenDatos: true, ObtenPermisosDelSistema: true, SistemaQueSeIngreso: 25, ModuloId: 1, FuncionId: 1, EsRequeridoValidacionDeInstitucion: true } }
      ]
    }
]

export default EQUITAS;


// WEBPACK FOOTER //
// ./src/router/EQUITAS.js